var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.454.455a.643.643 0 0 1 .909 0l8.182 8.181a.643.643 0 1 1-.91.91L.454 1.363a.643.643 0 0 1 0-.91Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.455 9.545a.643.643 0 0 1 0-.909L8.636.455a.643.643 0 0 1 .91.909L1.363 9.545a.643.643 0 0 1-.91 0Z",
    fill: "#838383"
  })));
};
export default SvgCross;